import { render, staticRenderFns } from "./IndustryTags.vue?vue&type=template&id=0aefa958"
import script from "./IndustryTags.vue?vue&type=script&lang=ts&setup=true"
export * from "./IndustryTags.vue?vue&type=script&lang=ts&setup=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports